import React, { Component } from "react";
import Navbar from "../navbar/navbar";
import "../home/home.css";
// import "./callforpaper.css";
class Publications extends Component {
	render() {
		return (
			<>
				<div className="header-area">
					<div id="home" className="contact-header-area  bg_cover">
						<Navbar />
						<div className=" d-flex align-items-center">
							<div className="container">
								<div className="row justify-content-center">
									<div className="col-lg-10">
										<div className="header-content text-center">
											<h2 className="header-title2">Publications</h2>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="container">
					<p
						className="callforpapertext text-justify"
						style={{
							color: "#EA5C2B",
							fontSize: "20px",
							paddingTop: "15px",
							fontWeight: "bold",
						}}
					>
						It is planned to publish the peer reviewed and selected papers of
						conference as proceedings with Springer in their prestigious
						“Lecture Notes in Electrical Engineering” series
						<a href="https://www.springer.com/series/7818">
							(https://www.springer.com/series/7818).
						</a>
						For detailed instructions for author and editors of conference
						proceedings, kindly visit the following link:
						<a href="https://www.springer.com/us/authors-editors/conference-proceedings.">
							https://www.springer.com/us/authors-editors/conference-proceedings.
						</a>
						Select papers from the conference will be published by Springer as a
						proceedings book volume. Springer will conduct quality checks on the
						accepted papers and only papers that pass these checks will be
						published. Springer Nature does not charge any money for publication
						of Non-Open Access content. Abstracts/extended abstracts and short
						papers (less than 4 pages) are not considered for publication.
					</p>
					<div style={{ display: "flex", justifyContent: "center" }}>
						<img
							src="https://media.springernature.com/w138/springer-static/cover/series/7818.jpg"
							alt="Book"
						/>
					</div>
				</div>
			</>
		);
	}
}

export default Publications;
